function s(n) {
  return typeof n == "string";
}
function u(n, r) {
  return Array.isArray(n) && n.every(r);
}
function f(n) {
  return typeof n == "number";
}
function t(n) {
  return n === void 0;
}
function o(n) {
  return !t(n);
}
function c(n) {
  return Array.isArray(n);
}
function e(n) {
  return typeof n == "object" && n !== null && "message" in n && typeof n.message == "string";
}
function i(n) {
  if (e(n))
    return n;
  try {
    return new Error(JSON.stringify(n));
  } catch {
    return new Error(String(n));
  }
}
function g(n) {
  return i(n).message;
}
export {
  g as getErrorMessage,
  c as isArray,
  e as isErrorWithMessage,
  o as isNotUndefined,
  f as isNumber,
  s as isString,
  u as isTypedArray,
  t as isUndefined
};
